module.exports = __webpack_public_path__ + "img/6.70562b51.png";